import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../../common/apiConfig';
import {
  MANAGE_OUTS_FETCH_STATE_COMPARE_BEGIN,
  MANAGE_OUTS_FETCH_STATE_COMPARE_SUCCESS,
  MANAGE_OUTS_FETCH_STATE_COMPARE_FAILURE,
  MANAGE_OUTS_FETCH_STATE_COMPARE_DISMISS_ERROR,
  MANAGE_OUTS_ERROR_CONTACT_ADMIN,
} from './constants';

export function fetchManageOutsStateCompare(formData = {}) {
  return (dispatch, getState) => {
    dispatch({ type: MANAGE_OUTS_FETCH_STATE_COMPARE_BEGIN });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;

      const payload = Object.keys(formData || {}).reduce((acc, k) => {
        const v = formData[k];
        if (v === undefined || v === '') return acc;
        acc[k] = v;
        return acc;
      }, {});

      axios.post(
        `${API_REQUEST_URL}/manageOutsStateCompare`,
        payload,
        { headers: { Authorization: token, 'Content-Type': 'application/json' } },
      ).then(
        (res) => {
          const data = res.data && res.data.data ? res.data.data : [];
          dispatch({ type: MANAGE_OUTS_FETCH_STATE_COMPARE_SUCCESS, data: { data } });
          resolve(data);
        },
        (err) => {
          //const errorMsg = err && err.response ? (err.response.data && err.response.data.message) || MANAGE_OUTS_ERROR_CONTACT_ADMIN : MANAGE_OUTS_ERROR_CONTACT_ADMIN;
          const errorMsg = `No Data Found`;
          dispatch({ type: MANAGE_OUTS_FETCH_STATE_COMPARE_FAILURE, data: { error: errorMsg } });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchManageOutsStateCompareError() {
  return { type: MANAGE_OUTS_FETCH_STATE_COMPARE_DISMISS_ERROR };
}

export function useFetchManageOutsStateCompare() {
  const dispatch = useDispatch();
  const { fetchStateComparePending, fetchStateCompareError } = useSelector(
    state => ({
      fetchStateComparePending: state.manageOutsAuditTrail.fetchStateComparePending,
      fetchStateCompareError: state.manageOutsAuditTrail.fetchStateCompareError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => dispatch(fetchManageOutsStateCompare(...args)), [dispatch]);
  const boundDismiss = useCallback(() => dispatch(dismissFetchManageOutsStateCompareError()), [dispatch]);

  return {
    fetchManageOutsStateCompare: boundAction,
    fetchStateComparePending,
    fetchStateCompareError,
    dismissFetchManageOutsStateCompareError: boundDismiss,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_OUTS_FETCH_STATE_COMPARE_BEGIN:
      return { ...state, fetchStateComparePending: true, fetchStateCompareError: null };
    case MANAGE_OUTS_FETCH_STATE_COMPARE_SUCCESS:
      return { ...state, fetchStateComparePending: false, fetchStateCompareError: null, stateCompareData: action.data.data || [] };
    case MANAGE_OUTS_FETCH_STATE_COMPARE_FAILURE:
      return { ...state, fetchStateComparePending: false, fetchStateCompareError: action.data.error };
    case MANAGE_OUTS_FETCH_STATE_COMPARE_DISMISS_ERROR:
      return { ...state, fetchStateCompareError: null };
    default:
      return state;
  }
}

